
<template>
  <v-checkbox v-model="checkbox" :rules="termsRules" class="terms-field">
    <template v-slot:label>
      <div>
       אני מאשר/ת את
        <span>
          <a
            target="_blank"
            href="https://www.drushim.co.il/article/2"
            @click.stop
          >
            התקנון
          </a>
          <a
            target="_blank"
            href="https://www.drushim.co.il/article/103"
            @click.stop
          >
            ומדיניות הפרטיות
          </a>
          באתר ומאשר/ת קבלת הצעות עבודה ותוכן שיווקי מאתר דרושים ו/או מצדדים שלישיים באמצעי הקשר שמסרתי (גם בשירותי דיוור ישיר)
        </span>
      </div>
    </template>
  </v-checkbox>
</template>

<script>
import { termsRules } from '@/lib/rules.js';

export default {
  data() {
    return {
      checkbox: false,
      termsRules
    };
  },

  watch: {
    checkbox() {
      this.applyTerms();
    }
  },

  methods: {
    applyTerms() {
      this.$emit('newTerms', this.checkbox);
    }
  }
};
</script>
